export enum Role {
    ADMIN = 'admin',
    ALMACEN = 'almacen',
    CLIENTE = 'cliente',
    NO_EXISTE = '',
}
